
export const TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
    ALERT: 'alert',
    INCOMPLETE: 'incomplete',
    MICROPHONE: 'microphone'
};
